import { Routes } from '@angular/router';
import { AccessMessageComponent } from '../pages/access-message/access-message.component';
import { LoginComponent } from '../pages/login/login.component';
import { AuthGuard } from '../services/auth-guard.service';

export const routes: Routes = [
  { path: '', loadChildren: () => import('../pages/warehouse/warehouse.module').then(m => m.WarehouseModule), canActivate: [AuthGuard] },
  { path: 'access', component: AccessMessageComponent },
  { path: 'login', component: LoginComponent },
  { path: '**', redirectTo: '' }
];
